module.exports = __webpack_public_path__ + "img/landing6.7e9425a4.jpg";